export const SHOP_SECTION_ID = 'shop-systems';

/** Scrolls to a section (smooth unless reduced motion) and moves focus to it. */
export function scrollToSection(id: string) {
  const el = document.getElementById(id);
  if (!el) return false;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  el.focus({ preventScroll: true });
  return true;
}
